import { render } from "./BoxServices.vue?vue&type=template&id=0e89bc69"
import script from "./BoxServices.vue?vue&type=script&lang=js"
export * from "./BoxServices.vue?vue&type=script&lang=js"

import "./BoxServices.vue?vue&type=style&index=0&id=0e89bc69&lang=css"

import exportComponent from "C:\\www\\webdesign - zelena\\vue\\dotacezelena-cz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__